/* js/slider-bild-text.js */

;(function($, window, document) {

$(window).load(function(){
    
  if (typeof $.fn.slick == 'function') {
      
      $('.slider-40-60').slick({
        autoplay: true,
        autoplaySpeed: 7000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true
    });
    
  }
    
});

})(jQuery, window, document);